import { ThemeMode } from '@partoohub/modular-components';

import useLocalStorage from 'app/common/hooks/useLocalStorage';

export const PARTOO_THEME_KEY = 'partoo_theme';

export const usePartooTheme = (): [string, (theme: string) => void] => {
    const [partooTheme, setPartooTheme] = useLocalStorage<string | undefined>(
        PARTOO_THEME_KEY,
        undefined,
    );

    const appliedTheme = partooTheme ?? ThemeMode.LIGHT;

    return [appliedTheme, setPartooTheme];
};
